import { render, staticRenderFns } from "./companyGood.vue?vue&type=template&id=edf878bc&scoped=true&"
import script from "./companyGood.vue?vue&type=script&lang=js&"
export * from "./companyGood.vue?vue&type=script&lang=js&"
import style0 from "./companyGood.vue?vue&type=style&index=0&id=edf878bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf878bc",
  null
  
)

export default component.exports